export default "__VITE_ASSET__2ed862c3__"